module.exports = __webpack_public_path__ + "static/media/back.a3047ebf.svg";